export const withoutElement = <T>(array: T[], element: T): T[] =>    {
    return array.filter(item => item !== element);
}
